import * as React from 'react';
import { connect } from 'react-redux';
import { CreateSurveyProps } from '../../common/CreateSurveyProps';
import { getQuestionTypeByCode, validateString } from '../../common/helperFunctions';
import { EditObject, QuestionType_MATRIX, QuestionType_MCQ, QuestionType_Text } from '../../common/constants';
import Mcq from './questionType/Mcq';
import Matrix from './questionType/Matrix';
import { ApplicationState } from '../../store';
import * as CreateSurveyStore from '../../store/CreateSurvey';

export interface iState {
    validationChecked: boolean,
    generalErrorMessage: string,
}

class AddQuestion extends React.Component<CreateSurveyProps, iState> {
    
    state = {
        validationChecked: false,
        generalErrorMessage: '',
    }

    constructor(props: any) {
        super(props);
           
    }

    handleChangeNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.target.value = e.target.value;
            
        this.props.SetPropertyCreateSurvey(EditObject.Question, e.target.name, '', false, +e.target.value, new Date());
    };

    handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.target.value = e.target.value;
            
        this.props.SetPropertyCreateSurvey(EditObject.Question, e.target.name, e.target.value, false, 0, new Date());
    };

    handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        e.target.value = e.target.value;
            
        this.props.SetPropertyCreateSurvey(EditObject.Question, e.target.name, e.target.value, false, 0, new Date());
    };

    handleSelectChangeNumber = (e: React.ChangeEvent<HTMLSelectElement>) => {

        this.props.SetPropertyCreateSurvey(EditObject.Question, e.target.name, '', false, +e.target.value, new Date());
    };

    handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        let isMandatory = false;
        
        if (e.target.value)
            isMandatory = true;

        this.props.SetPropertyCreateSurvey(EditObject.Question, e.target.name, '', isMandatory, 0, new Date());
    };

    CancelAndMoveNext = () => {
        if (this.props.survey.questions.length > 0)
            this.props.MoveNextStep(undefined);
        else
            this.setState({...this.state, generalErrorMessage : 'Please add at least one question' });
    }

    ValidateAndSave = () => {
        const other = this.props.editQuestion.mcqOptions.filter(a => a.isOther);
        if (other.length > 1) {
            this.setState({...this.state, validationChecked: true, generalErrorMessage : 'You can have only one "Other" MCQ' });

            return;
        }

        if (this.props.editQuestion.code === QuestionType_MCQ && this.props.editQuestion.mcqOptions.length === 0) {
            this.setState({...this.state, validationChecked: true, generalErrorMessage : 'Please add MCQ option(s)' });

            return;
        }

        if (validateString(true, this.props.editQuestion.questionEn, 1, -1) === false ||
            validateString(true, this.props.editQuestion.questionFr, 1, -1) === false) {
                
            this.setState({...this.state, validationChecked: true, generalErrorMessage : 'Please fill out the required fields above' });

            return;
        }

         if (
            this.props.editQuestion.code === QuestionType_MATRIX && (
            (this.props.editQuestion.matrixRows || []).length === 0 ||
            (this.props.editQuestion.matrixColumns || []).length === 0 )
            ) {
            this.setState({...this.state, validationChecked: true, generalErrorMessage : 'Please add Matrix question(s)/option(s)' });

            return;
        }

        this.props.EndQuestionEdit(false);
        this.setState({...this.state, 
            validationChecked: false,
            generalErrorMessage : '',
        });
    }

    render() {
        return(
            <React.Fragment>
                <div className="row g-3">
                    <div className='col-sm-12 col-md-6'>
                        <label className="form-label fw-bold">Question Type: <samp className="text-danger">&nbsp;*</samp></label>
                        <select className="form-select"
                                onChange={this.handleSelectChangeNumber}
                                value={this.props.editQuestion.questionTypeId}
                                disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                                name='questionTypeId'>
                            {this.props.questionType.map((t) => { return(<option key={t.id} value={t.id}>{t.name}</option>) })}
                        </select>
                        {(this.state.validationChecked && this.props.editQuestion.questionTypeId <= 0) && <div className="invalid-feedback d-block pt-1 pb-2">Required field</div>}
                    </div>
                </div>
                <div className="row g-3 mt-5">
                    <div className='col-sm-12'>
                        <label className="form-label fw-bold">Question: <samp className="text-danger">&nbsp;*</samp></label>
                        <input className="form-control"
                            type="text"
                            value={this.props.editQuestion.questionEn}
                            onChange={this.handleInputChange}
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            name='questionEn'
                            placeholder="English"
                            required></input>
                        {!validateString(this.state.validationChecked, this.props.editQuestion.questionEn, 1, -1) && <div className="invalid-feedback d-block pt-1 pb-2">Required field</div>}
                    </div>
                </div>
                <div className="row g-3">
                    <div className='col-sm-12'>
                        <input className="form-control"
                            type="text"
                            value={this.props.editQuestion.questionFr}
                            onChange={this.handleInputChange}
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            name='questionFr'
                            placeholder="French"
                            required></input>
                        {!validateString(this.state.validationChecked, this.props.editQuestion.questionFr, 1, -1) && <div className="invalid-feedback d-block pt-1 pb-2">Required field</div>}
                    </div>
                </div>
                {
                    this.props.editQuestion.questionTypeId !== getQuestionTypeByCode(this.props.questionType, QuestionType_MCQ).id 
                    && this.props.editQuestion.code !== QuestionType_MATRIX 
                    &&
                    this.renderPlaceHolder()
                }
                <div className="row g-3 mt-5">
                    <div className='col-sm-12 col-md-6'>
                        <label className="form-label fw-bold">Mandatory:</label>
                        <select className="form-select"
                                onChange={this.handleSelectChange}
                                disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                                defaultValue={this.props.editQuestion.isMandatory.toString()}
                                name='isMandatory'>
                            <option value='true'>Yes</option>
                            <option value='false'>No</option>
                        </select>
                    </div>
                </div>
                <div className="row g-3 mt-3">
                    <div className='col-sm-12'>
                        <label className="form-label fw-bold">Error Message: (This message will be shown in case of any error. e.g. answer not provided, missing selection, invalid input like invalid email or phone)</label>
                        <input type="text"
                            value={this.props.editQuestion.errorMessageEn}
                            onChange={this.handleInputChange}
                            className="form-control"
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            name='errorMessageEn'
                            placeholder="English"
                            required></input>
                    </div>
                </div>
                <div className="row g-3 mb-5">
                    <div className='col-sm-12'>
                        <input type="text"
                            value={this.props.editQuestion.errorMessageFr}
                            onChange={this.handleInputChange}
                            className="form-control"
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            name='errorMessageFr'
                            placeholder="French"
                            required></input>
                    </div>
                </div>
                {
                    (
                        (
                            this.props.editQuestion.questionTypeId ===  getQuestionTypeByCode(this.props.questionType, QuestionType_MCQ).id && 
                            <Mcq></Mcq>
                        ) ||
                        (
                            this.props.editQuestion.questionTypeId ===  getQuestionTypeByCode(this.props.questionType, QuestionType_MATRIX).id && 
                            <Matrix></Matrix>
                        )
                    )
                }
                {
                    (this.props.editQuestion.code ===  QuestionType_Text || 
                        ( this.props.editQuestion.code ===  QuestionType_MCQ )) &&
                    <>
                        <div className="row g-3">
                            <div className='col-sm-12 col-md-6'>
                                <label className="form-label fw-bold">Max character limit:</label>
                                <input type="number"
                                    value={this.props.editQuestion.maxCharacterLimit}
                                    onChange={this.handleChangeNumber}
                                    className="form-control"
                                    disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                                    name='maxCharacterLimit'
                                    min="1"
                                    max="1000"
                                    required></input>
                            </div>
                        </div>

                        {
                            this.props.editQuestion.questionTypeId ===  getQuestionTypeByCode(this.props.questionType, QuestionType_MCQ).id && 
                            //this.state.isOtherExists && 
                            this.renderPlaceHolder()
                        }
                    </>
                }

                <div className="row g-3">
                    <div className='col-sm-12'>
                        <div className="invalid-feedback d-block pt-1 pb-2">{this.state.generalErrorMessage}</div>
                    </div>
                </div>

                <div className="col-sm-12 mt-5">
                    <button className="btn btn-primary" onClick={() => this.props.MoveNextStep(this.props.step -1 )}>Previous</button>
                    <button className="btn btn-primary" onClick={() => this.ValidateAndSave()}
                    disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}>Add/Update</button>
                    <button className="btn btn-primary" onClick={() => this.CancelAndMoveNext()}>Cancel &amp; Continue</button>
                </div>
            </React.Fragment>
        );
    }

    renderPlaceHolder() {
        return (
        <>
            <div className="row g-3 mt-5">
                <div className='col-sm-12'>
                    <label className="form-label fw-bold">Placeholder:</label>
                    <input className="form-control"
                        value={this.props.editQuestion.placeholderEn}
                        onChange={this.handleInputChange}
                        name='placeholderEn'
                        disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                        placeholder="English"
                        required></input>
                </div>
            </div>
            <div className="row g-3">
                <div className='col-sm-12'>
                    <input className="form-control"
                        value={this.props.editQuestion.placeholderFr}
                        onChange={this.handleInputChange}
                        name='placeholderFr'
                        disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                        placeholder="French"
                        required></input>
                </div>
            </div>
        </>);
    }

};

export default connect(
    (state: ApplicationState) => state.createSurveyStore,
    CreateSurveyStore.actionCreators
)(AddQuestion as any);
